import { Dialog, DialogProps } from "./Dialog";

const MonophthongsTable = () => (
  <>
    <h5>Monophthongs (Single Vowel Sounds)</h5>
    <table>
      <thead>
        <tr>
          <th>IPA Symbol</th>
          <th>Example Word</th>
          <th>Description</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>/ɪ/</td>
          <td>bit, sit, ship</td>
          <td>Short, near-front, near-close</td>
        </tr>
        <tr>
          <td>/e/</td>
          <td>bed, pet, ten</td>
          <td>Short, front, mid</td>
        </tr>
        <tr>
          <td>/æ/</td>
          <td>cat, bat, trap</td>
          <td>Short, front, near-open</td>
        </tr>
        <tr>
          <td>/ʌ/</td>
          <td>cut, but, luck</td>
          <td>Short, central, mid</td>
        </tr>
        <tr>
          <td>/ʊ/</td>
          <td>put, foot, could</td>
          <td>Short, back, near-close</td>
        </tr>
        <tr>
          <td>/ɒ/</td>
          <td>hot, pot, rock</td>
          <td>Short, back, open</td>
        </tr>
        <tr>
          <td>/ə/</td>
          <td>about, sofa, banana</td>
          <td>Short, central, mid (schwa)</td>
        </tr>
        <tr>
          <td>/iː/</td>
          <td>see, meet, key</td>
          <td>Long, front, close</td>
        </tr>
        <tr>
          <td>/ɑː/</td>
          <td>car, father, hard</td>
          <td>Long, back, open</td>
        </tr>
        <tr>
          <td>/ɔː/</td>
          <td>saw, caught, law</td>
          <td>Long, back, mid</td>
        </tr>
        <tr>
          <td>/uː/</td>
          <td>too, moon, blue</td>
          <td>Long, back, close</td>
        </tr>
        <tr>
          <td>/ɜː/</td>
          <td>bird, fur, term</td>
          <td>Long, central, mid</td>
        </tr>
      </tbody>
    </table>
  </>
);

const DiphthongsTable = () => (
  <>
    <h5>
      <a href="https://www.youtube.com/watch?v=vL1iGL11Jzg" target="_blank">
        Diphthongs
      </a>{" "}
      (Two Vowel Sounds Blended Together)
    </h5>
    <table>
      <thead>
        <tr>
          <th>IPA Symbol</th>
          <th>Example Word</th>
          <th>Description</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>/eɪ/</td>
          <td>day, say, late</td>
          <td>Moves from /e/ to /ɪ/</td>
        </tr>
        <tr>
          <td>/aɪ/</td>
          <td>my, buy, high</td>
          <td>Moves from /a/ to /ɪ/</td>
        </tr>
        <tr>
          <td>/ɔɪ/</td>
          <td>boy, toy, coin</td>
          <td>Moves from /ɔ/ to /ɪ/</td>
        </tr>
        <tr>
          <td>/əʊ/</td>
          <td>go, slow, home</td>
          <td>Moves from /ə/ to /ʊ/</td>
        </tr>
        <tr>
          <td>/aʊ/</td>
          <td>now, out, loud</td>
          <td>Moves from /a/ to /ʊ/</td>
        </tr>
        <tr>
          <td>/ɪə/</td>
          <td>near, here, ear</td>
          <td>Moves from /ɪ/ to /ə/</td>
        </tr>
        <tr>
          <td>/eə/</td>
          <td>hair, there, care</td>
          <td>Moves from /e/ to /ə/</td>
        </tr>
        <tr>
          <td>/ʊə/</td>
          <td>poor, tour, sure</td>
          <td>Moves from /ʊ/ to /ə/</td>
        </tr>
      </tbody>
    </table>
  </>
);

const IPA = () => (
  <>
    <h4>
      IPA: vowels (monophthongs - simple, diphthongs - combined) and consonants
    </h4>
    <a href="https://www.youtube.com/watch?v=Ft17a7tyjMM" target="_blank">
      Video
    </a>
    <MonophthongsTable />
    <DiphthongsTable />
  </>
);

const EdSound = () => (
  <>
    <h4>-ed sounds as suffix in verb. For ease of transition</h4>
    <ul>
      <li>Voiceless end sound (except /t/): "-ed" sounds like /t/.</li>
      <li>Voiced end sound or vowel: "-ed" sounds like /d/.</li>
      <li>End sound is /t/ or /d/: "-ed" sounds like /ɪd/.</li>
    </ul>
  </>
);

export const Notes = (props: Omit<DialogProps, "title" | "children">) => {
  return (
    <Dialog {...props} title="Notes">
      <>
        <IPA />
        <EdSound />
      </>
    </Dialog>
  );
};
